import { AssetType } from '../enums/AssetType.js';
import type { IAsset, IUserPhotoAsset } from '../types/index.js';

export function isUserPhotoAsset(asset: IAsset): asset is IUserPhotoAsset {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return asset.type === AssetType.USER_PHOTO;
}
